/**
 * @generated SignedSource<<5781cbccd1c8eecb1569c5f9b0c8dc09>>
 * @relayHash 2bb1694d71660b70c596688bc417d3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3c1e078b8f837f9aa0d463343faa2b58625974fee0bd1da388729d4349cb736

import type { ConcreteRequest } from 'relay-runtime';
export type useAccessClassInclusionClassesQuery$variables = {
  cloudId: string;
};
export type useAccessClassInclusionClassesQuery$data = {
  readonly confluence_userClasses: {
    readonly nodes: ReadonlyArray<{
      readonly displayName: string;
      readonly principalId: string;
    }> | null;
  } | null;
};
export type useAccessClassInclusionClassesQuery = {
  response: useAccessClassInclusionClassesQuery$data;
  variables: useAccessClassInclusionClassesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceUserClassConnection",
    "kind": "LinkedField",
    "name": "confluence_userClasses",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceUserClass",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "principalId"
          },
          {
            "kind": "ScalarField",
            "name": "displayName"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessClassInclusionClassesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessClassInclusionClassesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2bb1694d71660b70c596688bc417d3f0",
    "id": "d3c1e078b8f837f9aa0d463343faa2b58625974fee0bd1da388729d4349cb736",
    "metadata": {},
    "name": "useAccessClassInclusionClassesQuery",
    "operationKind": "query",
    "text": "query useAccessClassInclusionClassesQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId,displayName}}}"
  }
};
})();

(node as any).hash = "b9df1c827cf7bec061b12334b26b99d9";

export default node;
